/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — the <style> holding the tenant `@import` statements
 *              (open_advanced option1), printed BEFORE every other tenant rule
 *   extends:   BbClassicStyleComponent
 *   template:  ec-tenant-css-imports.hbs
 *   args:      @imports (string[] from lib/tenant-css-split)
 *   uses:      lib/tenant-css-split (layerImport); BbClassicStyle `layered`
 *   siblings:  templates/application.hbs (BbClassicStyle with the rest of
 *              option1 right after this block)
 *   tests:     tenant-css-split-test.js, ui-nuova-ec-shell-test.js
 *   gotchas:   `layered` is the same switch BbClassicStyle uses for the rest of
 *              option1: when the classic CSS is compiled in `@layer classica`
 *              (service:ui enabled + cascade layers), each import gets
 *              ` layer(classica)` so the imported sheet keeps losing/winning
 *              against classic exactly like the tenant rules; otherwise the
 *              statement is printed as-is. Rendered as a TEXT node (not
 *              htmlSafe): `&` in a URL (Google Fonts `&display=swap`) stays
 *              literal; `<` is stripped like the safe-string pass of the rest.
 */
import BbClassicStyleComponent from 'beebee-base/components/bb-classic-style';
import { layerImport } from '../lib/tenant-css-split';

export default class EcTenantCssImportsComponent extends BbClassicStyleComponent {
  get css() {
    const imports = Array.isArray(this.args.imports) ? this.args.imports : [];
    const layered = this.layered;
    return imports
      .map((statement) => String(statement).replace(/</g, ''))
      .map((statement) => (layered ? layerImport(statement, 'classica') : statement))
      .join('\n');
  }
}
